
import { useLayoutEffect, useRef, useState } from 'react';

export type UseSvgBox = {
	refText: React.RefObject<SVGTextElement>;
	box: DOMRect;
};

export const useSvgBox = (measureKey?: unknown): { refText: React.RefObject<SVGTextElement>, box: DOMRect } => {
	const [content, setContent] = useState<string>('');
	const [box, setBoxState] = useState<DOMRect>({ x: 25, y: 25, width: 0, height: 0 } as DOMRect);
	const refText = useRef<SVGTextElement>(null);
	const lastKey = useRef<unknown>(measureKey);

	// Re-measure getBBox when text content changes or when measureKey changes (e.g. font size)
	// Using a ref for lastKey avoids feedback loops from getBBox comparison
	useLayoutEffect(() => {
		// read the ref in the effect, not during render -- on the render that (re)mounts the text the
		// render-phase value is still null, and a component that never renders again would stay unmeasured
		const element = refText.current ?? null;
		if (element && (element.textContent !== content || measureKey !== lastKey.current)) {
			const newBox = element.getBBox();
			// an unlaid-out element measures 0; leave the key unlatched so the next render tries again
			if (newBox.width === 0) return;
			setContent(element.textContent);
			lastKey.current = measureKey;
			setBoxState(newBox);
		}
	});

	return { refText, box };
};
